import { PolygonType, ScreeningPolygonStatus } from '../enums';
import { Reassessment } from '../common';

export class ScreeningPolygonResult {
    public type: PolygonType;
    public hasData: boolean;
    public factor: number;
    public polygonStatus: ScreeningPolygonStatus;
    public reassessment: Reassessment;
    public pollutant: string;

    public constructor(init: Partial<ScreeningPolygonResult>) {
        Object.assign(this, init);
    }
}
